/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const GET_DETAIL_TX_COUNT = 'GET_DETAIL_TX_COUNT';
export const GET_DETAIL_RICH_COUNT = 'GET_DETAIL_RICH_COUNT';
export const CLEAR_DETAIL = 'CLEAR_DETAIL';
